module.exports = __webpack_public_path__ + "static/media/mobile-icon.5d348adb.png";